/**
 * Test IDs for QA automation.
 */
export const testIds = {
  assetBusinessEntitySelectPicker: "asset-business-entity-select-picker",
  assetBusinessEntitySelectSearch: "asset-business-entity-select-search",
} as const;
